import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { Button } from '../../../atoms'
import AdminLayoutIndex from '../_layouts/'

interface IProps {
  settings: any
}

const AdminSettingsShow: React.FC<IProps> = props => {
  const boolToLabel = bool => (bool ? 'Yes' : 'No')
  const settings = props.settings.reduce((obj, setting) => {
    obj[setting.var] =
      typeof setting.value === 'boolean' ? boolToLabel(setting.value) : setting.value
    return obj
  }, {})

  const items = [
    {
      title: (
        <>
          {I18n.t('admin.settings.default_site')}
          <br />
          <small>{I18n.t('admin.settings.default_site_caption')}</small>
        </>
      ),
      valueKey: 'default_site',
    },
    { title: I18n.t('admin.settings.default_title'), valueKey: 'default_title' },
    { title: I18n.t('admin.settings.default_description'), valueKey: 'default_description' },
    { title: I18n.t('admin.settings.default_keywords'), valueKey: 'default_keywords' },
    { title: I18n.t('admin.settings.ga_tracking_id'), valueKey: 'ga_tracking_id' },
    { title: I18n.t('admin.settings.service_rate'), valueKey: 'service_rate' },
    { title: I18n.t('admin.settings.withholding_rate'), valueKey: 'withholding_rate' },
    { title: I18n.t('admin.settings.payment_required'), valueKey: 'payment_required' },
    { title: I18n.t('admin.settings.skip_profile'), valueKey: 'skip_profile' },
    { title: I18n.t('admin.settings.skip_identification'), valueKey: 'skip_identification' },
  ]

  return (
    <AdminLayoutIndex
      model="setting"
      title={I18n.t('activerecord.models.setting')}
      main={
        <S.Settings>
          <dl>
            {items.map((item, i) => (
              <React.Fragment key={i}>
                <dt>{item.title}</dt>
                <dd>{settings[item.valueKey]}</dd>
              </React.Fragment>
            ))}
          </dl>
          <S.Buttons>
            <Button primary={true}>
              <a href="/admin/setting/edit">{I18n.t('generic.edit')}</a>
            </Button>
          </S.Buttons>
        </S.Settings>
      }
    />
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.Settings = styled.div`
  dl {
    display: flex;
    flex-wrap: wrap;
  }
  dt {
    width: 50%;
    margin-top: 24px;
    font-weight: bold;
    font-size: 16px;
  }
  dd {
    width: 50%;
    margin-top: 24px;
  }
`

S.Buttons = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 48px;
  .Button[type='submit'] {
    width: 160px;
  }
`

export default AdminSettingsShow
